module.exports = __webpack_public_path__ + "img/ilegal-dude.c7b191f6.svg";